import * as React from "react";
import { Router } from "react-router-dom";

import { createHistory } from "../../modules/history";

export const RouterContext = React.createContext({} as any);

export const RelodeRouter = (props: { children?: React.ReactNode; baseUrl: string }) => {
    const history = React.useMemo(() => createHistory(props.baseUrl), [props.baseUrl]);
    return <Router history={history}>{props.children}</Router>;
};
